export function convertPercentage(value: number | undefined) {
  if (value && !Number.isNaN(value)) {
    return value / 100;
  }

  return null;
}
